import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger.js'

gsap.registerPlugin(ScrollTrigger)

gsap.defaults({ duration: 1 })

if (document.querySelector('.main__image-ibg img')) {
  gsap.from('.main__image-ibg img', {
    scale: 1.3,
    ease: 'power2.inOut',
    duration: 7,
    delay: 1,
  })
}

const media = window.matchMedia(`(min-width: ${767.98 / 16}rem)`)
if (media.matches) {
  if (document.querySelector('.main__icon .line')) {
    gsap.to('.main__icon .line', {
      attr: {
        y2: 40,
      },
      ease: 'none',
      duration: 0.8,
      repeat: -1,
      repeatDelay: 1,
      yoyo: true,
    })
  }

  const hAnimeElements = document.querySelectorAll('.h-anim')
  if (hAnimeElements) {
    hAnimeElements.forEach(el => {
      const headerAnim = gsap.timeline()
      headerAnim
        .from(el.querySelectorAll('.ht-anim'), {
          y: -50,
          opacity: 0,
        })
        .from(
          el.querySelectorAll('.hst-anim'),
          {
            x: 50,
            opacity: 0,
            stagger: 0.2,
          },
          '<'
        )

      ScrollTrigger.create({
        trigger: el,
        start: 'bottom 70%',
        animation: headerAnim,
      })
    })
  }

  const heightThinking = document.querySelector('.thinking__body')?.getBoundingClientRect().height - window.innerHeight
  if (document.querySelector('.thinking__button')) {
    gsap.to('.thinking__button', {
      ease: 'none',
      scrollTrigger: {
        trigger: '.thinking__button',
        start: 'center 70%',
        end: `=+${heightThinking} 70%`,
        scrub: true,
        pin: true,
        pinSpacing: false,
      },
    })
  }

  if (document.querySelector('.holiday__body')) {
    const welcomeAnim = gsap.timeline()
    welcomeAnim
      .from('.holiday__left-ibg', {
        y: -40,
        x: -40,
        opacity: 0,
      })
      .from(
        '.holiday__right-ibg',
        {
          y: -40,
          x: 40,
          opacity: 0,
        },
        '<'
      )
      .from(
        '.holiday__center-ibg',
        {
          y: 40,
          opacity: 0,
        },
        '<'
      )
    ScrollTrigger.create({
      trigger: '.holiday__body',
      start: '80% bottom',
      animation: welcomeAnim,
    })
  }
}
